import { render, staticRenderFns } from "./TournamentBracket.vue?vue&type=template&id=3bd7b93a&"
import script from "./TournamentBracket.vue?vue&type=script&lang=js&"
export * from "./TournamentBracket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports